import React from "react";
import { Button, Dropdown } from "react-bootstrap";

export default function PopoverFilterWrapper(props) {
  return (
    <Dropdown show={props.show} className="dropdown-inline custom-dropdown-toggle">
      <Dropdown.Toggle onClick={() => props.setShow(!props.show)} variant="primary" className={`btn btn-sm `}>
        {props.label}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ width: "auto", minWidth: "300px" }} className="py-0">
        <div className="px-7 py-5">
          <div className="fs-5 text-dark fw-bolder">Filter Options</div>
        </div>
        <div className="separator border-gray-200"></div>
        <div className="px-7 py-5">
          <div className="mb-4">{props.children}</div>
          <div className="d-flex justify-content-end">
            {props.showCancel && (
              <Button className="btn btn-sm btn-light btn-active-light-primary me-2" onClick={props.onCancelClick}>
                {props.cancelButtonText}
              </Button>
            )}
            {props.showSave && (
              <Button className="btn btn-sm btn-primary" onClick={props.onSaveClick}>
                {props.saveButtonText}
              </Button>
            )}
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
